import React from 'react';
import { getAuthenticatedUser } from '@edx/frontend-platform/auth';

import { format, useMessages } from '../i18n';
import { catalogUrl } from '../links';
import { useCartCount } from './hooks';
import { CartIcon, HeartIcon } from './parts';

// Wishlist and cart (with item count) in the signed-in learner header
// (org.openedx.frontend.layout.header_desktop_secondary_menu.v1).
export const HeaderShop = () => {
  const t = useMessages();
  const count = useCartCount();
  return (
    <span className="bm-header-shop">
      <a className="bm-header-shop__link" href={catalogUrl('wishlist')} title={t.shWishlist} aria-label={t.shWishlist}>
        <HeartIcon />
      </a>
      <a
        className="bm-header-shop__link"
        href={catalogUrl('cart')}
        title={t.shCart}
        aria-label={count ? format(t.shCartCount, { n: count }) : t.shCart}
      >
        <CartIcon />
        {count > 0 && <span className="bm-header-shop__count" aria-hidden="true">{count > 9 ? '9+' : count}</span>}
      </a>
    </span>
  );
};

// Phone menu (header_mobile_main_menu.v1): text links, signed-in only.
export const MobileHeaderShop = () => {
  const t = useMessages();
  const count = useCartCount();
  if (!getAuthenticatedUser()) { return null; }
  return (
    <>
      <a className="nav-link" href={catalogUrl('cart')}>{count ? `${t.shCart} (${count})` : t.shCart}</a>
      <a className="nav-link" href={catalogUrl('wishlist')}>{t.shWishlist}</a>
      <a className="nav-link" href={catalogUrl('orders')}>{t.shMyOrders}</a>
    </>
  );
};
